import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import CourseWrapperMediator from './CourseWrapperMediator';

const courseWrapperTabWhitelistRegex =
    /\/(courseDescription|course|registration|finalTest|certificate|courseEval|resources)$/;

const MediatorRoot = ownProps => {
    // second param might be either pawn shortHash or course wrapper tab, so handle both cases
    let matchPath = ownProps.match.path;
    if (
        matchPath.includes('/:shortHash') &&
        (!ownProps.match?.params?.shortHash ||
            /(courseDescription|course|registration|finalTest|certificate|courseEval|resources)/.test(
                ownProps.match?.params?.shortHash || ''
            ))
    ) {
        matchPath = matchPath.slice(0, matchPath.indexOf('/:shortHash'));
    }

    return (
        <Route
            path={`${matchPath}/:courseWrapperTab?`}
            render={props => {
                const basePath = ownProps.match.url.replace(courseWrapperTabWhitelistRegex, '');
                return <CourseWrapperMediator {...ownProps} {...props} basePath={basePath} />;
            }}
        />
    );
};

export default withRouter(MediatorRoot);
